import { render, staticRenderFns } from "./OrganisationStructure.vue?vue&type=template&id=6273a481&"
import script from "./OrganisationStructure.vue?vue&type=script&lang=js&"
export * from "./OrganisationStructure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports